var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgStop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M60.278 13.067l37.129 61.344c1.43 2.362.674 5.437-1.689 6.867-.78.472-1.676.722-2.589.722H18.871c-2.762 0-5-2.239-5-5 0-.913.25-1.808.722-2.589l37.13-61.344c1.43-2.362 4.504-3.118 6.866-1.688.691.418 1.27.997 1.689 1.688z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E5E8FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 3c0 1.657-16.118 3-36 3S0 4.657 0 3s16.118-3 36-3 36 1.343 36 3",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(18 99) matrix(1 0 0 -1 0 6)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFFA",
    d: "M57.715 22.858l29.468 49.113c.568.947.26 2.176-.686 2.744-.311.186-.667.285-1.03.285H26.533c-1.104 0-2-.895-2-2 0-.362.099-.718.285-1.029l29.468-49.113c.568-.947 1.797-1.254 2.744-.686.281.17.517.405.686.686z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#272C4D",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(55 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 17,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    y: 20,
    rx: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStop2);
export default __webpack_public_path__ + "static/media/img-stop2.dc305859f1c86c24ed410b839148786d.svg";
export { ForwardRef as ReactComponent };